import { createContext } from "react";
import { LineItemContextPropsHook } from "components/job/LineItem/LineItemContext/useLineItemContextProps";
import { LineItemVariant } from "../constants";

export type LineItemContextValue = LineItemContextPropsHook;

const LineItemContext = createContext<LineItemContextValue>({
  classNames: {} as LineItemVariant,
});

export default LineItemContext;
